module.exports = d3;


//////////////////
// WEBPACK FOOTER
// external "d3"
// module id = 853
// module chunks = 0